import React from 'react';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import { useWatchButton } from './useWatchButton';
const WatchButton = ({ children, user, disabled = false, isWatchingBack, initialData, onToggleWatchSuccess })=>{
    var _initialData_isWatching;
    const { text, onClick, biData, isLoading, isWatching } = useWatchButton(user, (_initialData_isWatching = initialData === null || initialData === void 0 ? void 0 : initialData.isWatching) !== null && _initialData_isWatching !== void 0 ? _initialData_isWatching : user.isWatching, isWatchingBack, disabled, onToggleWatchSuccess);
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "WatchButton"
    }, children({
        text,
        onClick,
        disabled,
        isLoading,
        isWatching,
        biData
    }));
};
WatchButton.displayName = 'WatchButton';
export default WatchButton;
